import { MailingAttachmentStatusEnum } from '@zaoblako/shared/modules/notification/enums/mailing-attachment-status.enum';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link MailingAttachmentStatusEnum} enumeration values */
export const MailingAttachmentStatusEnumI18n: EnumI18nInterface<MailingAttachmentStatusEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [MailingAttachmentStatusEnum.NOT_SENT]: 'Не отправлен',
    [MailingAttachmentStatusEnum.SENT]: 'Отправлен',
  },
  [I18nLocalesEnum.EN_US]: {
    [MailingAttachmentStatusEnum.NOT_SENT]: 'Not sent',
    [MailingAttachmentStatusEnum.SENT]: 'Sent',
  },
};
